import { default as React } from 'react';
import { makeStyles, Typography, Button } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
  },
  icon: {
    fontSize: '3rem',
    marginBottom: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  message: {
    color: theme.palette.text.secondary,
    textAlign: 'center',
    maxWidth: '400px',
    marginBottom: theme.spacing(2),
  },
  action: {
    marginTop: theme.spacing(2),
  },
}));

interface EmptyStateProps {
  message: string;
  onAction?: () => void;
  actionLabel?: string;
  icon?: React.ReactNode;
}

const EmptyState = React.memo(({ message, onAction, actionLabel, icon }: EmptyStateProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {icon && <div className={classes.icon}>{icon}</div>}
      <Typography variant="body1" className={classes.message}>
        {message}
      </Typography>
      {onAction && actionLabel && (
        <Button
          onClick={onAction}
          color="primary"
          variant="outlined"
          className={classes.action}
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
});

export default EmptyState;
